import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SharedDataService } from '../../../../service/shared-data.service';

const MaxImageRetry = 3;

@Component({
  selector: 'app-custom-login-provider',
  templateUrl: './custom-login-provider.component.html',
  styleUrls: ['./custom-login-provider.component.scss'],
})
export class CustomLoginProviderComponent implements OnInit {
  @Input() providers: any;
  @Input() viewType: any;
  @Input() remember_me: boolean = false;
  requestId: string = '';
  constructor(private _dataService: SharedDataService) { }

  ngOnInit(): void {
    this._dataService._getRequestId().subscribe((res) => {
      if (res) {
        this.requestId = res;
        this.providers = this.providers.filter((provider: any) => provider.isProviderVisible == true );
      }
    });
  }

  _actionCustomProvider(provider) {
    let social_url = environment.base_url + '/login-srv/social';
    if (provider && provider.provider_name) {
      let url = social_url + '/' + this.viewType + '/'
        + provider.provider_name.toLowerCase() + '/' + this.requestId
        + '?remember_me=' + this.remember_me

      window.location.href = url;
    }
    return false;
  }

  handleImageError(event: ErrorEvent, index: number) {
    if (!event.target) {
      return;
    }
    if (this.providers[index].errorRetry === undefined) {
      this.providers[index].errorRetry = 0;
    }
    if (this.providers[index].errorRetry < MaxImageRetry) {
      (event.target).removeEventListener('error', null);
      this.providers[index].forceDefaultLogo = true;
    }
    this.providers[index].errorRetry++;

  }
}
